import { QueryClient } from "@tanstack/react-query";

// Own module so the callable layer can invalidate the cache without importing App.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      // Once, but never for not-found: the refresh after a delete asks for the deleted item.
      retry: (failureCount, error) =>
        failureCount < 1 && !`${(error as { code?: string }).code ?? ""} ${error.message}`.includes("not-found"),
    },
  },
});
